
export function updateFaviconWithCount(count: number) {
    const canvas = document.createElement('canvas');
    const size = 32; // Base size of the favicon
    canvas.width = size;
    canvas.height = size;
  
    const ctx = canvas.getContext('2d');
    const favicon = new Image();
  
    // Ensure the favicon source is correct
    favicon.src = `/favicon/favicon-32x32.png?cacheBust=${Date.now()}`;
  
    favicon.onload = () => {
      if (ctx) {
        // Draw the base favicon
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(favicon, 0, 0, size, size);
  
        if (count > 0) {
          // Adjust badge position slightly left and down
          const badgeX = 24; // X position of the badge center
          const badgeY = 10; // Y position of the badge center
          const badgeRadius = 10;
  
          // Badge Background
          ctx.fillStyle = 'red';
          ctx.beginPath();
          ctx.arc(badgeX, badgeY, badgeRadius, 0, 2 * Math.PI);
          ctx.fill();
  
          // Badge Text
          ctx.fillStyle = 'white';
          ctx.font = 'bold 14px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(
            count > 99 ? '99+' : count.toString(),
            badgeX,
            badgeY
          );
        }
  
        // Update the favicon
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = canvas.toDataURL('image/png');
  
        // Remove existing favicon links
        const oldLinks = document.querySelectorAll('link[rel="icon"]');
        oldLinks.forEach((oldLink) => oldLink.parentNode?.removeChild(oldLink));
  
        // Append the new favicon
        document.head.appendChild(link);
      }
    };
  
    favicon.onerror = () => {
      console.error('Failed to load favicon image.');
    };
  }